import React from "react";
import styled from "styled-components";
import { ellipsis, rgba, shade } from "polished";
import { Button as RebassButton } from "rebass";

const Button = styled(RebassButton)`
  color: ${(props) => props.theme.colors.grey[0]};
  ${ellipsis()};
  background: transparent;
  border: ${(props) => props.theme.borders[1]};
  border-color: ${(props) => props.theme.colors.grey[0]};
  cursor: pointer;
  transition: color 500ms cubic-bezier(0.23, 1, 0.32, 1),
    background-color 500ms cubic-bezier(0.23, 1, 0.32, 1),
    border-color 500ms cubic-bezier(0.23, 1, 0.32, 1);
  will-change: color, background-color;
  user-select: none;

  &:hover {
    color: ${(props) => props.theme.colors.grey[2]};
    background: ${(props) => props.theme.colors.grey[0]};
    border-color: ${(props) => props.theme.colors.grey[0]};
  }

  &:focus {
    color: ${(props) => props.theme.colors.grey[2]};
    background: ${(props) => props.theme.colors.grey[0]};
    border-color: ${(props) => props.theme.colors.grey[0]};
    outline: 4px solid
      ${(props) =>
        props.theme.colors.text && rgba(props.theme.colors.grey[0], 0.5)};
    box-shadow: none;
  }

  &:active {
    color: ${(props) => props.theme.colors.grey[2]};
    background: ${(props) =>
      props.theme.colors.text && shade(0.875, props.theme.colors.grey[0])};
    border-color: ${(props) =>
      props.theme.colors.text && shade(0.875, props.theme.colors.grey[0])};
  }
`;

Button.defaultProps = {
  is: "button",
  m: 0,
  px: 16,
  py: 13,
  fontSize: 16,
  fontWeight: "normal",
  lineHeight: 0,
  borderRadius: 0,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Buttons/Button.js